module.exports = __webpack_public_path__ + "static/media/card_grid_skeleton.d60ee3a7.svg";